import { render, staticRenderFns } from "./groupManage.vue?vue&type=template&id=e706f5c4&"
import script from "./groupManage.vue?vue&type=script&lang=js&"
export * from "./groupManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports